import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, ChevronLeft, X, Volume2, VolumeX, UserCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

const SLIDES = {
  nl: [
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/2972be24f11a4dcb848cfdff7e6e5a4295989df0ba525cf2fdd40b7953f208c9.png',
      title: 'Welkom bij Krypton9!',
      body: 'Ik ben Emma, jouw persoonlijke AI-assistent. Ik leer je bedrijf kennen en help je met slimme analyses, strategische inzichten en automatisering. Laat me je even rondleiden!',
      audio: `${API}/api/static/tour/slide_1.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/eec1b6332259aa564c3ea55ad1b535413befd75d6e240a80c1af44a8725264a0.png',
      title: '16 AI-tools voor je bedrijf',
      body: 'Van financiele analyses tot klantinzichten, van verkoopstrategieen tot marktonderzoek. Elk tool is speciaal ontworpen voor MKB-ondernemers en levert direct bruikbare resultaten.',
      audio: `${API}/api/static/tour/slide_2.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/b2fa04d59d9ce0c9d78bf1422fd31b7db2c0f244253a9ab85d6ca5387f41a616.png',
      title: 'Emma leert en onthoudt',
      body: 'Ik onthoud gesprekken, leer je voorkeuren en word steeds slimmer. Mijn "Brein" combineert alles wat ik weet om je de best mogelijke adviezen te geven.',
      audio: `${API}/api/static/tour/slide_3.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/866282ed2320d28cb9f16c80011812b01394ff4ae4d6a59a87b3a81f556a382d.png',
      title: 'Je Bedrijfsprofiel als Digital Twin',
      body: 'Vul je bedrijfsprofiel in en ik gebruik die data als basis voor alle analyses. Hoe completer je profiel, hoe nauwkeuriger mijn inzichten worden.',
      audio: `${API}/api/static/tour/slide_4.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/ef893e427a1b6b2085316c9d5b3cd86bd36339df79c8a0a3639832988ea9bcca.png',
      title: 'Kennisbank uploaden',
      body: 'Upload documenten zoals jaarverslagen, contracten of marktonderzoeken. Ik analyseer ze en gebruik de kennis om je nog betere adviezen te geven.',
      audio: `${API}/api/static/tour/slide_5.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/cb78a1a2d82b6b37f24c73b9ef6d78698517517c70f492dbe8c15657cd8ccfe9.png',
      title: 'Credits & Betaling',
      body: 'Elke AI-analyse kost credits. Je begint met gratis credits en kunt eenvoudig bijkopen via iDEAL, creditcard of Google Pay. Zo betaal je alleen voor wat je gebruikt.',
      audio: `${API}/api/static/tour/slide_6.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/d5c005aae95a14c63fbca8b500cff000adca78bcee75e4c5da63b845abd334ad.png',
      title: 'Klaar om te beginnen!',
      body: 'Begin met het invullen van je bedrijfsprofiel en probeer een AI-tool uit. Ik sta altijd rechtsonder klaar om je te helpen. Veel succes!',
      audio: `${API}/api/static/tour/slide_7.mp3`,
    },
  ],
  en: [
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/2972be24f11a4dcb848cfdff7e6e5a4295989df0ba525cf2fdd40b7953f208c9.png',
      title: 'Welcome to Krypton9!',
      body: 'I\'m Emma, your personal AI assistant. I get to know your business and help you with smart analyses, strategic insights and automation. Let me give you a quick tour!',
      audio: `${API}/api/static/tour/slide_1_en.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/eec1b6332259aa564c3ea55ad1b535413befd75d6e240a80c1af44a8725264a0.png',
      title: '16 AI Tools for Your Business',
      body: 'From financial analyses to customer insights, from sales strategies to market research. Each tool is specially designed for SME entrepreneurs and delivers directly actionable results.',
      audio: `${API}/api/static/tour/slide_2_en.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/b2fa04d59d9ce0c9d78bf1422fd31b7db2c0f244253a9ab85d6ca5387f41a616.png',
      title: 'Emma Learns and Remembers',
      body: 'I remember conversations, learn your preferences and get smarter over time. My "Brain" combines everything I know to give you the best possible advice.',
      audio: `${API}/api/static/tour/slide_3_en.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/866282ed2320d28cb9f16c80011812b01394ff4ae4d6a59a87b3a81f556a382d.png',
      title: 'Your Company Profile as Digital Twin',
      body: 'Fill in your company profile and I\'ll use that data as the foundation for all analyses. The more complete your profile, the more accurate my insights become.',
      audio: `${API}/api/static/tour/slide_4_en.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/ef893e427a1b6b2085316c9d5b3cd86bd36339df79c8a0a3639832988ea9bcca.png',
      title: 'Upload Your Knowledge Base',
      body: 'Upload documents such as annual reports, contracts or market research. I analyze them and use the knowledge to give you even better advice.',
      audio: `${API}/api/static/tour/slide_5_en.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/cb78a1a2d82b6b37f24c73b9ef6d78698517517c70f492dbe8c15657cd8ccfe9.png',
      title: 'Credits & Payment',
      body: 'Each AI analysis costs credits. You start with free credits and can easily top up via iDEAL, credit card or Google Pay. You only pay for what you use.',
      audio: `${API}/api/static/tour/slide_6_en.mp3`,
    },
    {
      image: 'https://static.prod-images.emergentagent.com/jobs/f7c2c964-661f-4c9c-ba76-0f7252267498/images/d5c005aae95a14c63fbca8b500cff000adca78bcee75e4c5da63b845abd334ad.png',
      title: 'Ready to Get Started!',
      body: 'Begin by filling in your company profile and try out an AI tool. I\'m always available in the bottom right corner to help you. Good luck!',
      audio: `${API}/api/static/tour/slide_7_en.mp3`,
    },
  ],
};

const LABELS = {
  nl: { prev: 'Vorige', next: 'Volgende', finish: 'Bedrijfsprofiel invullen', speaking: 'Emma spreekt...' },
  en: { prev: 'Previous', next: 'Next', finish: 'Fill in Company Profile', speaking: 'Emma is speaking...' },
};

const WelcomeTour = ({ onComplete }) => {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const slides = SLIDES[lang] || SLIDES.nl;
  const labels = LABELS[lang] || LABELS.nl;
  const [slide, setSlide] = useState(0);
  const [muted, setMuted] = useState(false);
  const [speaking, setSpeaking] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const audioElRef = useRef(null);
  const advanceRef = useRef(null);
  const isLast = slide === slides.length - 1;
  const current = slides[slide];

  const clearAdvance = () => {
    if (advanceRef.current) { clearTimeout(advanceRef.current); advanceRef.current = null; }
  };

  // Play audio on the persistent <audio> element — always called from a click handler
  const playSlideAudio = (slideIndex) => {
    const el = audioElRef.current;
    if (!el || muted) return;
    const src = slides[slideIndex].audio;
    el.src = src;
    el.load();
    el.play().then(() => {
      setSpeaking(true);
    }).catch(() => {
      setSpeaking(false);
    });
  };

  const stopAudio = () => {
    const el = audioElRef.current;
    if (el) {
      el.pause();
      el.currentTime = 0;
    }
    setSpeaking(false);
  };

  // "Start met geluid" — first user gesture unlocks the <audio> element
  const handleUnlockAndPlay = () => {
    setAudioReady(true);
    setMuted(false);
    playSlideAudio(slide);
  };

  const handleNext = () => {
    stopAudio();
    const next = slide + 1;
    setSlide(next);
    if (audioReady && !muted) playSlideAudio(next);
  };

  const handlePrev = () => {
    stopAudio();
    const prev = slide - 1;
    setSlide(prev);
    if (audioReady && !muted) playSlideAudio(prev);
  };

  const handleDot = (i) => {
    stopAudio();
    setSlide(i);
    if (audioReady && !muted) playSlideAudio(i);
  };

  const handleMuteToggle = () => {
    if (!muted) {
      stopAudio();
      setMuted(true);
    } else {
      setMuted(false);
      if (audioReady) playSlideAudio(slide);
    }
  };

  const handleClose = () => {
    stopAudio();
    onComplete();
  };

  const handleFinish = () => {
    stopAudio();
    onComplete();
    navigate('/portal/company-profile');
  };

  const handleFinishOrNext = () => {
    if (isLast) handleFinish();
    else handleNext();
  };

  // Auto-advance through the tour so the user does not have to click Next each time.
  // When audio plays, the <audio> onEnded handler advances on its own. When muted,
  // advance after an estimated reading time. Always stops on the last slide, and
  // clears on unmount / manual navigation (the effect re-runs when `slide` changes).
  useEffect(() => {
    clearAdvance();
    if (isLast || !muted) return;          // audio onEnded drives it when not muted
    const words = `${current.title} ${current.body}`.split(/\s+/).length;
    const est = Math.max(5000, words * 380);
    advanceRef.current = setTimeout(() => handleNext(), est);
    return clearAdvance;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide, muted, isLast]);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 10000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)',
    }} data-testid="welcome-tour">
      {/* Persistent audio element in DOM — never removed */}
      <audio
        ref={audioElRef}
        preload="auto"
        onEnded={() => {
          setSpeaking(false);
          // narration finished -> move to the next slide automatically
          if (!muted && audioReady && !isLast) handleNext();
        }}
        onError={() => {
          setSpeaking(false);
          // audio failed -> don't get stuck; advance after a short pause
          if (!muted && audioReady && !isLast) {
            clearAdvance();
            advanceRef.current = setTimeout(() => handleNext(), 4000);
          }
        }}
        style={{ display: 'none' }}
      />

      <div style={{
        background: '#0E1620', borderRadius: '16px', maxWidth: '640px', width: '92vw',
        overflow: 'hidden', boxShadow: '0 24px 64px rgba(0,0,0,0.25)',
        animation: 'fadeIn 0.3s ease-out',
      }}>
        {/* Image */}
        <div style={{ position: 'relative', width: '100%', aspectRatio: '3/2', overflow: 'hidden' }}>
          <img src={current.image} alt={current.title}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }} />

          {/* Top-right controls */}
          <div style={{ position: 'absolute', top: 12, right: 12, display: 'flex', gap: 8 }}>
            <button onClick={handleMuteToggle}
              data-testid="tour-mute" style={{
                background: 'rgba(0,0,0,0.45)', border: 'none', borderRadius: '50%',
                width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', color: '#fff',
              }}>
              {muted ? <VolumeX size={15} /> : <Volume2 size={15} />}
            </button>
            <button onClick={handleClose} data-testid="tour-skip" style={{
              background: 'rgba(0,0,0,0.45)', border: 'none', borderRadius: '50%',
              width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', color: '#fff',
            }}><X size={16} /></button>
          </div>

          {/* Speaking indicator */}
          {speaking && (
            <div style={{
              position: 'absolute', bottom: 12, left: 12,
              background: 'rgba(0,0,0,0.55)', borderRadius: 20, padding: '4px 12px',
              display: 'flex', alignItems: 'center', gap: 6, color: '#fff', fontSize: '0.75rem',
            }}>
              <Volume2 size={13} style={{ animation: 'pulse 1.5s ease-in-out infinite' }} /> {labels.speaking}
            </div>
          )}

          {/* Unlock audio prompt — shown until user clicks */}
          {!audioReady && !muted && (
            <button onClick={handleUnlockAndPlay} data-testid="tour-unlock-audio" style={{
              position: 'absolute', bottom: 16, left: '50%', transform: 'translateX(-50%)',
              background: 'rgba(0,0,0,0.7)', border: '2px solid rgba(255,255,255,0.5)',
              borderRadius: 24, padding: '8px 20px',
              display: 'flex', alignItems: 'center', gap: 8,
              color: '#fff', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer',
              backdropFilter: 'blur(4px)',
            }}>
              <Volume2 size={16} /> {lang === 'nl' ? 'Start met geluid' : 'Start with audio'}
            </button>
          )}
        </div>

        {/* Content */}
        <div style={{ padding: '1.75rem 2rem 1.5rem' }}>
          <h2 style={{ fontSize: '1.35rem', fontWeight: 700, marginBottom: '0.6rem', color: '#F4F7FB' }}>
            {current.title}
          </h2>
          <p style={{ fontSize: '0.95rem', lineHeight: 1.6, color: '#555', minHeight: '3.2rem' }}>
            {current.body}
          </p>

          {/* Progress dots */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 6, margin: '1.25rem 0 1rem' }}>
            {(Array.isArray(slides) ? slides : []).map((_, i) => (
              <div key={i} data-testid={`tour-dot-${i}`} onClick={() => handleDot(i)} style={{
                width: i === slide ? 24 : 8, height: 8, borderRadius: 4,
                background: i === slide ? '#1a1a1a' : '#16202C',
                transition: 'all 0.3s ease', cursor: 'pointer',
              }} />
            ))}
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem' }}>
            <button onClick={handlePrev} disabled={slide === 0}
              data-testid="tour-prev" style={{
                padding: '0.6rem 1.2rem', borderRadius: 8, border: '1px solid #ddd',
                background: '#0E1620', cursor: slide === 0 ? 'default' : 'pointer',
                opacity: slide === 0 ? 0.3 : 1, display: 'flex', alignItems: 'center', gap: 4,
                fontSize: '0.9rem', color: '#F4F7FB', transition: 'opacity 0.2s',
              }}>
              <ChevronLeft size={16} /> {labels.prev}
            </button>

            <button onClick={handleFinishOrNext}
              data-testid={isLast ? 'tour-finish' : 'tour-next'} style={{
                padding: '0.6rem 1.5rem', borderRadius: 8, border: 'none',
                background: isLast ? '#16a34a' : '#1a1a1a', color: '#fff',
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
                fontSize: '0.9rem', fontWeight: 600, transition: 'background 0.2s',
              }}>
              {isLast && <UserCircle size={16} />}
              {isLast ? labels.finish : labels.next} {!isLast && <ChevronRight size={16} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeTour;
